import { render, staticRenderFns } from "./TemplateFonts.vue?vue&type=template&id=a894c66c"
import script from "./TemplateFonts.vue?vue&type=script&lang=js"
export * from "./TemplateFonts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports